import { render, staticRenderFns } from "./device-selector.vue?vue&type=template&id=59d35dc2&scoped=true"
import script from "./device-selector.vue?vue&type=script&lang=js"
export * from "./device-selector.vue?vue&type=script&lang=js"
import style0 from "./device-selector.vue?vue&type=style&index=0&id=59d35dc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d35dc2",
  null
  
)

export default component.exports